import { FC, ReactElement } from "react";

type NoneWrapperProps = {
  show: boolean;
  children: ReactElement | ReactElement[] | string;
};
const NoneWrapper: FC<NoneWrapperProps> = ({ show, children }) => {
  if (!show) {
    return <></>;
  } else {
    return <>{children}</>;
  }
};

export default NoneWrapper;
export { NoneWrapper };
